import Image from 'next/image'
import styles from './testimonial.module.scss'

const TestimonialItem = ({ userReviewItem, index = 0, isBusinessPage = false }) => (
  <div className={styles.testimonialCard} key={`${userReviewItem.customerName}${index}`}>
    <div className={styles.cardProfile}>
      <div className={styles.cardProfilePhoto}>
        <Image
          src={userReviewItem?.userProfilePicture?.data?.attributes?.url}
          alt={`Card Profile Photo Icon ${index}`}
          width={48}
          height={48}
          loading="lazy"
        />
      </div>
      <div className={styles.cardProfileInfo}>
        <p>{userReviewItem.customerName}</p>
        <p>{userReviewItem.userRatingRecordedDate}</p>
      </div>
    </div>

    <div className={`${styles.customerReview} ${isBusinessPage ? styles.newFont : ''}`}>{userReviewItem.userRatingReview}</div>
  </div>
)

export default TestimonialItem
